import { useMutation } from "@tanstack/react-query";
import { loginCompany, selectCompanyLogin } from "services/companyAuth";
import { useCompanyAuthStore } from "store/companyAuth";

export const useLoginCompany = () => {
  const setCompanyAuthData = useCompanyAuthStore(
    (state) => state.setCompanyAuthData
  );

  const query = useMutation({
    mutationKey: ["login-company"],
    mutationFn: (data) => loginCompany(data),
    onSuccess: (data) => {
      // Only set auth data if we got a token (single company login)
      if (data.token) {
        setCompanyAuthData(data);
      }
      // If requiresSelection is true, we don't set auth data yet
    },
  });

  return query;
};

export const useSelectCompanyLogin = () => {
  const setCompanyAuthData = useCompanyAuthStore(
    (state) => state.setCompanyAuthData
  );

  const query = useMutation({
    mutationKey: ["select-company-login"],
    mutationFn: (data) => selectCompanyLogin(data),
    onSuccess: (data) => {
      setCompanyAuthData(data);
    },
  });

  return query;
};

